import { Component, OnInit, ViewChild } from '@angular/core';

import { UserService } from 'src/app/services/user.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { Session } from 'src/app/models/session';
import { MapChartComponent } from '../map-chart/map-chart.component';
import { MatTableDataSource, MatPaginator, MatSort, Sort } from '@angular/material';

@Component({
  selector: 'app-my-tickets',
  templateUrl: './my-tickets.component.html',
  styleUrls: ['./my-tickets.component.css']
})
export class MyTicketsComponent implements OnInit {

  constructor(public session: Session, private service: UserService, private toast: ToastrService, private activatedRoute: ActivatedRoute, private datePipe: DatePipe){

  }

  @ViewChild('map',null) map:MapChartComponent;
  
  @ViewChild(MatPaginator,{static: false}) paginator: MatPaginator;
  @ViewChild(MatSort,null) sort: MatSort;
  
  getMapData(){
    return this.tickets;
  }
  

  filtro = "Abiertos";
  filtroText = "";
  tickets = [];

  tecnicos_asignados = [];
  filtroTecnico = "todos";
  filtroProvincia = "todos";
  ticketsDS;

  displayedColumns = ["id","fecha_alta","proxima_visita","tecnico_asignado","garantia","cliente","status","zona","calificacion"];

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(q=>{
      this.filtro = q.status;
      if(!this.filtro) this.filtro = "TODOS";
      this.service.getTickets(q.status).subscribe(d=>{
        this.tickets = d.sort( (a,b) => {return -1});
        this.tickets.forEach(x=> x.proxima = x.visitas[x.visitas.length-1].fecha);
        this.tickets.forEach( x => x.tecnico_label =  x.tecnico_asignado?(x.tecnico_asignado.legajo + ' ' + x.tecnico_asignado.nombre + ' ' + x.tecnico_asignado.apellido):'' );
        this.tickets.forEach( x => x.tecnico_label +=  x.garantia + ' ' + x.nombre + ' ' + x.apellido + ' ' + x.email + ' ' + x.id);
        this.tickets.forEach( x => x.provincia =  x.zona.provincia);
        this.addTecnicosAsignados();
        this.ticketsDS = new MatTableDataSource<any>(this.tickets);
        this.ticketsDS.paginator = this.paginator;
        setTimeout(() => {          
          this.map.updateMap();
        }, 1000);
      }, er=>{
        this.toast.error("Algo salió mal");
      })
    });
  }


  sortData(sort: Sort) {
    const data = this.tickets.slice();
    if (!sort.active || sort.direction === '') {
      this.ticketsDS = new MatTableDataSource<any>(data);
      this.ticketsDS.paginator = this.paginator;
      return;
    }

    this.ticketsDS = new MatTableDataSource<any>(data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'id':
          return compare(a.id, b.id, isAsc);
        case 'fecha_alta':
          return compare(a.fecha_alta, b.fecha_alta,isAsc);  
        default:
          return 0;
      }
    }));
    this.ticketsDS.paginator = this.paginator;
  }

  



  getStatusColor(status){
    switch(status){
      case "CANCELADO": return "#FE9AA2";
      case "FINALIZADO": return "#067E38";
      case "EN ESPERA": return "#B6C8EC";
      case "LISTO": return "#8bc34a";
      default: return "";

    }
  }



  statusFilter = "ALL";
  filter = "";

  addTecnicosAsignados(){
    this.tickets.forEach(x=>{
      if(x.tecnico_asignado){
        if(this.tecnicos_asignados.findIndex(j=> j._id == x.tecnico_asignado._id) < 0) this.tecnicos_asignados.push(x.tecnico_asignado);
      }
    })
   this.tecnicos_asignados = this.tecnicos_asignados.sort(function(a,b){ return a.apellido>b.apellido?1:-1}); 
  }

  getTicketsFromProvinciaCount(provincia){
    return this.tickets.filter(x=> x.zona.provincia == provincia).length;
  }


  getTicketsFromTecnicoCount(tecnico_id){
    return this.tickets.filter(x=> x.tecnico_asignado &&  x.tecnico_asignado._id == tecnico_id).length;
  }



  getCsv(){
    if(this.desde == null || this.hasta == null) return;    
    this.service.getTicketsCsv(this.desde, this.hasta, this.filtro).subscribe(d=>{
      this.createCsv(d);
    }, er=>{
      console.log(er);
      
      if(er.status!=200){
        this.toast.error(er.error);
      }
      else this.createCsv(er.error.text);
    })
  }

  createCsv(content){
    var element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(content));
      let file_name = "Tickets_" + this.filtro + "_" + this.desde + "_al_" + this.hasta + ".csv";
      element.setAttribute('download', file_name);
  
      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
  }


  getCsv2(){
    if(this.desde == null || this.hasta == null) return;

    console.log(this.desde,this.hasta);
    
    this.service.getFallasCsv(this.desde, this.hasta, this.filtro).subscribe(d=>{
      this.createCsv(d);
    }, er=>{
      if(er.status!=200){
        this.toast.error(er.error);
      }
      else this.createCsv2(er.error.text);
    })
  }

  createCsv2(content){
    var element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(content));
      let file_name = "Fallas_" + this.filtro + "_" + this.desde + "_al_" + this.hasta + ".csv";
      element.setAttribute('download',file_name);
  
      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
  }


  desde = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
  hasta = this.datePipe.transform(new Date(), 'yyyy-MM-dd');



}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}